import { render, staticRenderFns } from "./DevelopersSettings.vue?vue&type=template&id=7b015808"
import script from "./DevelopersSettings.vue?vue&type=script&lang=js"
export * from "./DevelopersSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports